module.exports = __webpack_public_path__ + "static/media/quezishan3.4ae88d08.webp";